<div class="main-container">
    <div class="container">

        <div class="video-container" *ngIf="!error">
            <video [class.show]="!isCaptured" [class.hide]="isCaptured" #video id="video" [width]="WIDTH"
                [height]="HEIGHT" autoplay></video>
            <canvas [class.show]="isCaptured" [class.hide]="!isCaptured" #canvas id="canvas" [width]="WIDTH"
                [height]="HEIGHT"></canvas>
        </div>

        <div class="snap-container">

            <div *ngIf="!isCaptured" (click)="capture()" class="sendbutton mat-elevation-z4" matRipple
                [matRippleRadius]="300" [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
                <span class="buttontext">Tomar Imagen</span>
            </div>

            <div *ngIf="isCaptured" (click)="removeCurrent()" class="sendbutton2 mat-elevation-z4" matRipple
                [matRippleRadius]="300" [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
                <span class="buttontext">Tomar Otra</span>
            </div>


           <!--  <button *ngIf="!isCaptured" (click)="capture()">Snap Photo</button>
            <button *ngIf="isCaptured" (click)="removeCurrent()">Take Another</button>
 -->
            <!--  <div *ngIf="error" class="text-danger mt-4">
        {{ error }}. Please click refresh on stackblitz
        <div class="mt-5">
            <img src="https://trungk18.com/7e0976255739e721501803ee074f1f94/camera.gif" />
        </div>
    </div> -->
        </div>

        <div class="pictures-taken">
            <ul class="list-unstyled">
                <li *ngFor="let src of captures; let idx = index" (click)="setPhoto(idx)">
                    <img [src]="src" height="50" />
                </li>
            </ul>
        </div>

        <!--  <div>
            <button (click)="saveImage()">Guardar Imagen</button>
        </div> -->
        <div (click)="saveImage()" class="sendbutton mat-elevation-z4" matRipple [matRippleRadius]="300"
            [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
            <span class="buttontext">Guardar Imagen</span>
        </div>

    </div>
</div>